import { fromJS } from 'immutable';

import { localStorage } from '../../../kodyl/web-storage';
import { jwtDecode } from 'jwt-decode';

import { persistToken } from '../utils/persistence';
import { CREATE_SUCCESS as ORG_CREATE_SUCCESS } from './organizations';

const SIGNUP = 'AUTH/SIGNUP';
export const SIGNUP_SUCCESS = 'AUTH/SIGNUP_SUCCESS';
const SIGNUP_FAIL = 'AUTH/SIGNUP_FAIL';
const SESSION = 'user/SESSION';
const SESSION_SUCCESS = 'user/SESSION_SUCCESS';
const SESSION_FAIL = 'user/SESSION_FAIL';
export const LOGOUT = 'user/LOGOUT';
const LOGIN = 'user/LOGIN';
const LOGIN_SUCCESS = 'user/LOGIN_SUCCESS';
const LOGIN_FAIL = 'user/LOGIN_FAIL';
const UPDATE = 'user/UPDATE';
const UPDATE_SUCCESS = 'user/UPDATE_SUCCESS';
const ROLES = 'user/ROLES';
const ROLES_SUCCESS = 'user/ROLES_SUCCESS';
const ROLES_FAIL = 'user/ROLES_FAIL';

export const UPDATE_FAIL = 'user/UPDATE_FAIL';

const initialState = {
  token: localStorage.getItem('lltoken') || null,
  user: null
};

const USERS_ENDPOINT = '/api/users';
const AUTH_ENDPOINT = '/api/auth';

const ADMIN = 'admin';

function decodeToken(token) {
  if (!token) {
    return {};
  }

  try {
    return jwtDecode(token);
  } catch (err) {
    return {};
  }
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case SESSION_SUCCESS:
    case UPDATE_SUCCESS:
    case SIGNUP_SUCCESS: {
      const {
        token,
        email,
        name,
        firstname,
        lastname,
        company,
        companyAddress,
        cvr,
        phone,
        type,
        verified,
        emailVerified,
        phoneVerified,
        roles,
        role
      } = action.payload.result;

      if (state.token !== token) {
        persistToken(token);
      }

      const decoded = decodeToken(token);

      return {
        ...state,
        token,
        user: fromJS({
          id: decoded.id,
          token,
          email,
          name,
          firstname,
          lastname,
          company,
          companyAddress,
          cvr,
          phone,
          type,
          verified,
          emailVerified,
          phoneVerified,
          roles,
          role
        })
      };
    }

    case ORG_CREATE_SUCCESS: {
      const {
        payload: { result }
      } = action;

      if (!state.user) {
        return state;
      }

      const role = {
        role: ADMIN,
        organization: result.uuid,
        name: result.name
      };

      const roles = state.user.get('roles') || fromJS([]);

      return {
        ...state,
        user: state.user.set('roles', roles.push(fromJS(role)))
      };
    }

    case ROLES_SUCCESS:
      if (!state.user) {
        return state;
      }

      return {
        ...state,
        user: state.user.set('roles', fromJS(action.payload.result || []))
      };

    case LOGOUT:
      return {
        ...state,
        token: null,
        user: null
      };

    default:
      return state;
  }
}

export function signup(data) {
  return {
    types: [SIGNUP, SIGNUP_SUCCESS, SIGNUP_FAIL],
    promise: (client) => client.post(`${USERS_ENDPOINT}`, { data })
  };
}

export function getSession() {
  return {
    types: [SESSION, SESSION_SUCCESS, SESSION_FAIL],
    promise: (client) =>
      client.get(`${USERS_ENDPOINT}/me`).catch((err) => {
        if (err && err.message === 'HTTP_401') {
          persistToken(null);
        }

        throw err;
      })
  };
}

export function login(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: (client) => client.post(`${AUTH_ENDPOINT}`, { data })
  };
}

export function update(data) {
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: (client) => client.post(`${USERS_ENDPOINT}/me`, { data })
  };
}

export function getRoles() {
  return {
    types: [ROLES, ROLES_SUCCESS, ROLES_FAIL],
    promise: (client) => client.get(`${USERS_ENDPOINT}/me/roles`)
  };
}

export function logout() {
  persistToken(null);

  return {
    type: LOGOUT
  };
}
